export const CATEGORIES = `
  query categories {
    categories {
      id
      name
    }
  }
`;
